import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { explainSimMatchup, SimModel, SimulationMatchup } from '../services/api';
import { AISummaryPanel } from './AISummaryPanel';

interface SimMatchupSummaryProps {
  site: string;
  asOf: string;
  model: SimModel;
  excludeTracks: string[];
  /** The matchup on screen (null while it's still simulating). */
  matchup: SimulationMatchup | undefined;
}

/** AI summary at the top of the matchup view: who the simulation favors among the chosen drivers and why. */
export const SimMatchupSummary: React.FC<SimMatchupSummaryProps> = ({ site, asOf, model, excludeTracks, matchup }) => {
  const key = matchup ? matchup.drivers.map((d) => `${d.driver}=${d.groupWinProb.toFixed(3)}`).sort().join('|') : '';
  const { data, isFetching, error, refetch } = useQuery<{ explanation: string }, Error>({
    queryKey: ['simMatchupExplain', site, asOf, model, [...excludeTracks].sort().join('|'), key],
    queryFn: () => explainSimMatchup(site, asOf, matchup!, excludeTracks, model),
    enabled: !!matchup,
    staleTime: Infinity,
    retry: false,
  });

  return (
    <AISummaryPanel
      label="AI summary of this matchup"
      isLoading={!matchup || (isFetching && !data)}
      error={error}
      text={data?.explanation}
      onRetry={() => refetch()}
    />
  );
};
